import { createSlice } from '@reduxjs/toolkit'
import { Task } from './taskTypes.ts'

export interface TasksState {
  task: Task | null
  activeTask: boolean
  loading: boolean
  error: string | null
}

const initialState: TasksState = {
  task: null,
  activeTask: true,
  loading: false,
  error: null,
}

const tasksSlice = createSlice({
  name: 'tasks',
  initialState,
  reducers: {
    setTask: (state, { payload }) => {
      state.task = payload
    },
    setActiveTask: (state, { payload }) => {
      state.activeTask = payload
    },
    setErrorTasK: (state, { payload }) => {
      state.error = payload
    },
    resetTaskState: () => initialState,
  },
})

export const { setTask, setActiveTask, setErrorTasK, resetTaskState } =
  tasksSlice.actions

export default tasksSlice.reducer
